import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
    const padding = theme.spacing(2);
    return {
        paneContent: {
            padding,
        },
        attachmentsPane: {
            paddingBottom: padding,
        },
        missingDataWrapper: {
            height: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(),
            margin: theme.spacing(),
        },
    };
});
